import api from './api';

const ENDPOINT = 'imports';

const ImportService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
};

export default ImportService;
